export const RankingCategoryTypes = {
    CITY: 'city',
    STATE: 'state',
    COUNTRY: 'country',
    WORLD: 'world',
};

export const LeaderboardParamValues = {
    TENNIS_RATING_TYPE: 'Tennis',
    AGE_OR_SEGMENT: 'AgeOrSegment',
    SINGLES_TENNIS: 'Singles',
    DOUBLES_TENNIS: 'Doubles',
};
export const LeaderboardTabTypes = {
    TOP_ONE_HUNDRED: 1,
    CLOSE_IN_RANK: 2,
};

export const LeaderboardTabLabels = {
    [LeaderboardTabTypes.TOP_ONE_HUNDRED]: 'Top 100',
    [LeaderboardTabTypes.CLOSE_IN_RANK]: 'Close In Rank',
};

export const AgeGroupCategoryTypes = {
    CITY_AGE_GROUP_RANK: 'CityAgeGroupRank',
    STATE_AGE_GROUP_RANK: 'StateAgeGroupRank',
    COUNTRY_AGE_GROUP_RANK: 'CountryAgeGroupRank',
    WORLD_AGE_GROUP_RANK: 'WorldAgeGroupRank',
};

export const SegmentCategoryTypes = {
    SEGMENT_CITY_RANK: 'SegmentCityRank',
    SEGMENT_STATE_RANK: 'SegmentStateRank',
    SEGMENT_COUNTRY_RANK: 'SegmentCountryRank',
    SEGMENT_WORLD_RANK: 'SegmentWorldRank',
};

export const LeaderboardSubtitles = {
    [LeaderboardTabTypes.TOP_ONE_HUNDRED]: 'Up to 100 of the top players.',
    [LeaderboardTabTypes.CLOSE_IN_RANK]: 'Up to 10 players ranked closest to you.',
};

export const LocalizedRankingsInfoText = {
    title: 'Understanding Your Verified Rankings',
    text: 'Your verified ranking is displayed for each category and location. The green/red indicator shows how your ranking has changed since last week.',
};

export const LocalizedRankingsCtaText = {
    SELF: { emphasis: 'Click your rank', rest: ' to see your local competition.' },
    OTHER: { emphasis: 'Click their rank', rest: ' to see their local competition.' },
};

export const eligibleCountryCodes = [
    'USA',
    'CAN',
    'AUS',
];

export const RANK_THRESHOLD = 5000;

export const LeaderboardTrackingData = {
    TITLE: 'view_leaderboard_modal',
    TOP_ONE_HUNDRED_TYPE: 'topOneHundred',
    CLOSE_IN_RANK_TYPE: 'relative',
    LOCALIZED_RANKINGS_FEATURE: 'player local rankings',
    LEADERBOARD_FEATURE: 'player leaderboard',
};
